import { gatewayPhone } from "src/gateways/gatewayPhone";
import { UpdateCallConfigInput, updateCallConfigSchema } from "../schemas/call-flow.schema";

export const updateCallFlow = async (
    companyId: number,
    payload: UpdateCallConfigInput,
) => {
    const parsedPayload = updateCallConfigSchema.parse(payload);

    const response = await gatewayPhone.patch(
        `company-call-config/${companyId}/flow`,
        parsedPayload,
    );

    return response;
};